import { format } from 'date-fns';

/**
 * Convert a Date object to a string in the format 'yyyy-MM-dd'.
 * @param date - The Date object to convert.
 */
export const dateToString = (date: Date | string | null): string | null => {
  if (date === null || date === undefined) {
    // If the input is null or undefined, return an empty string.
    return null;
  }

  if (typeof date === 'string') {
    // If the input is already a string, return it as is.
    return date;
  }

  const dateFormat = 'yyyy-MM-dd';
  return format(date, dateFormat);
};
